export default __webpack_public_path__ + "static/media/banner-40.1263f95e.jpg";